import { Badge } from "@blurb/codex-react";
import { Box, createStyles } from "@mantine/core";
import { IconV3 } from "@rpi/openapi-core";
import { GraphQL } from "@rpi/openapi-api";
import React from "react";
import { resolveStatusBadge, statusBadgeIconColor, StatusBadgeColor } from "./statusBadge.util";

const useStyles = createStyles(() => ({
  badgeWrapper: {
    display: "inline-flex",
    alignItems: "center",
  },
  icon: {
    fontVariationSettings: "'FILL' 1",
  },
}));

type OrderItemStatusConfig = Record<
  GraphQL.OrderItemStatus,
  {
    name: string;
    color: StatusBadgeColor;
  }
>;

const orderItemStatusConfig: OrderItemStatusConfig = {
  [GraphQL.OrderItemStatus.AwaitingProcessing]: {
    name: "Awaiting Processing",
    color: "gray",
  },
  [GraphQL.OrderItemStatus.Processing]: {
    name: "Processing",
    color: "orange",
  },
  [GraphQL.OrderItemStatus.ProcessingSuccess]: {
    name: "Processing Success",
    color: "green",
  },
  [GraphQL.OrderItemStatus.ProcessingFailed]: {
    name: "Processing Failed",
    color: "red",
  },
  [GraphQL.OrderItemStatus.PreflightSuccess]: {
    name: "Preflight Success",
    color: "blue",
  },
};

interface OrderItemStatusCellProps {
  status?: GraphQL.OrderItemStatus | null;
}

export const OrderItemStatusCell: React.FC<OrderItemStatusCellProps> = ({ status }) => {
  const { classes } = useStyles();
  if (!status) return null;
  const config = resolveStatusBadge(orderItemStatusConfig, "OrderItemStatus", status);
  const iconColor = statusBadgeIconColor(config.color);

  return (
    <Box className={classes.badgeWrapper}>
      <Badge
        label={config.name}
        color={config.color}
        variant="round"
        size="small"
        border={true}
        icon={<IconV3 icon="circle" size={12} color={iconColor} className={classes.icon} />}
      />
    </Box>
  );
};
